import { PlannerBase }   from "../../planner_base";
import { TaskEditorBase} from './base';
import watch from "redux-watch";
import isEqual from 'is-equal';
import { Global, CellPosition, LineSelectedSchedule, LineSelectedTask }  from "../model";
class Editor extends PlannerBase {
  colorcode: string;
  title: string;
  selected: boolean = false;
  init(){
    super.init();
    this.watch();
    this.watchPlannerData('selectedTask', (newVal: any, oldVal: any, objectPath: string) => { this.onChangeSelectedTask(newVal, oldVal, objectPath)});
  }
  onChangeSelectedTask(selectedTask: LineSelectedTask, oldVal, objectPath) {
    this.onSelectedTask(selectedTask);
  }
  onSelectedTask(selectedTask: LineSelectedTask){
    if(selectedTask == null){
      this.unSelect(selectedTask);
    } else {
      this.select(selectedTask);
    }
  }
  unSelect(selectedTask: LineSelectedTask){
    if(!this.selected){ return; }
    this.beforeUnselect(selectedTask);
    this.selected = false;
    this.update();
  }
  select(selectedTask: LineSelectedTask){
    this.beforeSelect(selectedTask);
    this.selected = true;
    this.update();
    if(this.opts.multiple){
      this.move(selectedTask);
    }
  }
  beforeUnselect(selectedTask: LineSelectedTask){

  }
  beforeSelect(selectedTask: LineSelectedTask){
    let phaseData = selectedTask.phaseData();
    this.title = phaseData.name;
    this.colorcode = phaseData.colorcode;
  }
  move(selectedTask: LineSelectedTask){
    let order_id = selectedTask.orderId();
    let el = document.getElementById("planner_order_" + order_id)
    $(this.rootElement()).insertAfter(el);
    // el.insertAdjacentHTML('afterend', this.rootElement());
  }
}
riot.mixin('orders.planner.task.editor', Editor as riot.TagMixin)
